import React from 'react';
import { NavLink } from 'react-router-dom';
import { local_routes, feature_names } from 'utils/Routes';
import './style.css';
import Select from 'react-select';

import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import { assembleNickname } from 'utils/Helper';

import UserContext from 'store/UserContext';

export default class UserTable extends React.Component{
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            selected_access_level_option: this.props.userData.access_level_option || {},
            toggle_value: this.props.toggle_value || ''
        };
    }
    
    onClickEdit = () => {
        this.props.OnEditUser(this.props.userData);
    }
    
    onClickRemove = () => {
        this.props.OnRemoveUser(this.props.userData);
    }

    onToggleChange = (toggle_value) => {
        this.setState({
            toggle_value
        });
        if (this.props.onToggleChange) {
            this.props.onToggleChange(this.props.userData,toggle_value);
        }
    }
    
    onChangeDropdown = (selectedOption) => {
        this.setState({
            selected_access_level_option: selectedOption
        });
        this.props.OnChangeDropdown(this.props.userData,selectedOption);
    }

    render(){
        //console.log("UserTable render",this.props.userData.access_level_option);
        //let selected_dropdown_option = null;
        //if (this.props.dropdown_options) {
        //    selected_dropdown_option = ""
        //}
        let workspace_base_url = "";
        if (this.props.workspace_base_url) {
            workspace_base_url = this.props.workspace_base_url;
        }
        return (
            <tr>
                <td style={{ fontSize: "smaller" }}>{this.props.userData.entity_name || assembleNickname(this.props.userData)}</td>
                <td style={{ fontSize: "smaller" }}>{this.props.userData.email || <em>hidden</em>}</td>
                <td style={{ fontSize: "smaller" }}>
                    <NavLink target="_blank" to={`${workspace_base_url}${local_routes.users}/${this.props.userData.friendly_url}`}>
                        {this.props.userData.friendly_url}
                    </NavLink>
                </td>
                <td>
                    { this.props.dropdown_options &&
                    <div style={{fontSize:"smaller"}}>
                        <Select
                            closeMenuOnSelect={true}
                            value={this.state.selected_access_level_option}
                            onChange={this.onChangeDropdown}
                            options={this.props.dropdown_options}
                            isMulti={false}
                            styles={{ menuPortal: base => ({ ...base, color: 'black', fontSize: "smaller", zIndex: 9999 }) }}
                            menuPortalTarget={document.querySelector('body')} // so dropdown is not cutoff
                        />
                    </div>
                    }
                    { this.props.togglebutton_options &&
                    <div style={{fontSize:"smaller"}}>
                        <ToggleButtonGroup
                          size="sm"
                          type="radio"
                          name="my_toggle_button"
                          value={this.state.toggle_value}
                          onChange={this.onToggleChange}
                        >
                        { this.props.togglebutton_options.map( (element,index) => (
                          <ToggleButton
                            key={index}
                            //variant="outline-dark"
                            variant={this.context.theme === 'dark' ? "outline-light" : "outline-dark"}
                            value={element.value}
                            //disabled={!entity_info.publishable}
                          >
                            {this.state.toggle_value === element.value ? element.adj_label : element.verb_label}
                          </ToggleButton>
                        ))}
                        </ToggleButtonGroup>
                    </div>
                    }
                </td>
                { (this.props.OnEditUser || this.props.OnRemoveUser) &&
                <td className="pkButtons">

                    { this.props.OnEditUser &&
                    <div>
                        <button className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" onClick={this.onClickEdit}>
                            Edit
                        </button>
                    </div>
                    }
                    { this.props.OnRemoveUser &&
                    <div>
                        <button className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" onClick={this.onClickRemove}>
                            Remove from {feature_names.Workspace}
                        </button>
                    </div>
                    }
                </td>
                }
            </tr>
        );
    }
}